import React from "react";

// Segmented control used for the Weekly/Monthly/Yearly-style toggles.
export default function TspToggleGroup({ options, value, onChange }) {
  return (
    <div className="tsp-toggle-group" role="tablist">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={option.value === value}
          className={`tsp-toggle-option ${option.value === value ? "active" : ""}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
